import React, { useEffect, useState, useCallback } from 'react';
import { CreateReport } from '../../../components';
import { paths } from '../../../routes';
import * as Yup from 'yup';
import { useAnomalies } from '../../../hooks/theme.hook';
import { useApi } from '../../../hooks';

export const Forms: React.FC = () => {
    const { selectedAnomalyType, anomalyTypes, anomalies, handleOnSelectAnomalyType } = useAnomalies(
        '' + paths.restauration.themeShortCode
    );

    const [enabledProducts, setEnabledProducts] = useState<any>([]);
    console.log(enabledProducts, enabledProducts.reduce(
        (obj: any, item: any) => Object.assign(obj, {
            [item?.name]: {
                type: 'input-range',
                label: [item?.name],
                grid: 6,
            }
        }), {}))
    const { getEnabledProducts } = useApi();
    const getProducts = useCallback(async () => {
        try {
            const products = await getEnabledProducts();
            console.log(products)

            setEnabledProducts(products);
        } catch (error) {
            console.log('get EnabledProducts error', error);
        }
    }, [getEnabledProducts]);
    console.log(' console.log(enabledProducts[enabledProducts?.lenght]?.id)', enabledProducts[enabledProducts?.length - 1]?.id)
    useEffect(() => {
        getProducts();
    }, [getProducts]);
    return (
        <CreateReport
            initialValues={{
                fieldReportsDto: {},
            }}
            themeShortCode={paths.restauration.themeShortCode || ''}
            otherFields={{
                'fieldReportsDto.inventory': {
                    type: 'radio',
                    label: 'Etat des lieux',
                    grid: 12,
                    options: [
                        {
                            value: 'Prise de service',
                            label: 'Prise de service',
                        },
                        {
                            value: 'Fin de service',
                            label: 'Fin de service',
                        },
                    ],
                },
                anomalyTypeShortCode: {
                    type: 'select',
                    label: "Type d'anomalie",
                    grid: 6,
                    options: anomalyTypes,
                },
                anomalyShortCode: {
                    type: 'select',
                    label: 'Anomalie',
                    grid: 6,
                    options: anomalies,
                    disabled: !selectedAnomalyType,
                },
                ...enabledProducts.reduce(
                    (obj: any, item: any, index: any) => Object.assign((obj), {
                        [item?.name]: {
                            type: 'input-range',
                            label: <div style={true ? {} : {}} > {index === 0 && <><h2>PRODUITS</h2>< br /></>}{index === 1 && <><div style={{ marginTop: "62px" }}>{' '}</div>< br /></>}{[item?.name]}</div >,
                            grid: 6,
                        }
                    }), {}),
                'fieldReportsDto.comment': {
                    type: 'text',
                    label: 'Commentaire',
                    multiline: true,
                    rows: 4,
                    rowsMax: 15,
                },

            }}
            onChange={handleOnSelectAnomalyType}
            validationSchema={Yup.object({
                anomalyTypeShortCode: Yup.string().required('Ce champ est requis'),
                anomalyShortCode: Yup.string().required('Ce champ est requis'),
                serviceName: Yup.string().required('Ce champ est requis').nullable(),
                fieldReportsDto: Yup.object({
                    inventory: Yup.string().required('Ce champ est requis')
                })
            })}
        />
    );
};

export default Forms;
